import { render, staticRenderFns } from "./PlayerCom.vue?vue&type=template&id=79dbdf1a&scoped=true&"
import script from "./PlayerCom.vue?vue&type=script&lang=js&"
export * from "./PlayerCom.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCom.vue?vue&type=style&index=0&id=79dbdf1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dbdf1a",
  null
  
)

export default component.exports